import { combineReducers } from 'redux'
import _ from 'lodash'

import * as list from './list'
import * as markRead from './markRead'
import * as markAllRead from './markAllRead'
import * as remove from './remove'

const slices = {
  list,
  markRead,
  markAllRead,
  remove
}

const notificationTypes = _.mapValues(slices, (s) => s.slice.types)
const notificationActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const notificationSagas = _(slices).values().map('slice.sagas').flatten().value()
const notificationSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { notificationTypes, notificationActions, notificationSagas, notificationSelectors }

export default combineReducers(reducers)
